<template>
    <div id="misionpage">
        <div class="container-fluid">
            <div class="row main-content">
                <div class="col-md-6" data-aos="fade-up">
                    <div class="medium-title">
                        <h2>{{state.misionTitle}}</h2>
                        <hr>
                        <p style="width:400px;">{{state.misionText}}</p>
                    </div>
                    <div class="medium-title">
                        <h2>{{state.visionTitle}}</h2>
                        <hr>
                        <p style="width:400px;">{{state.visionText}}</p>
                    </div>
                </div>
                <div class="col-md-6 img-contnt" data-aos="fade-left">
                    <img src="./../../assets/imgs/nosotros_foto2.png" width="90%">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

    methods: {
    },
    components: {
    },
    computed: {
        state() {
            return this.$store.state.activeList.aboutUsMain
        }
    },
    mounted() {

    }
}
</script>

<style lang="scss" scoped>
@import '~varmix';

#misionpage {
    background-color: $azul;
    color: white;
    margin-top: -200px;
}

.main-content {
    margin-top: 200px;
}

h2 {
    color: white;
    display: inline-block;
}

hr {
    display: inline-block;
    vertical-align: middle;
    height: 2px;
    border: 0;
    width: 30%;
    border-top: 2px solid $rojo;
    margin: 1em 1em;
    padding: 0;
}

\ .text-container {
    text-align: left;
    margin-top: 5%;
}

.medium-title {
    text-align: left;
    vertical-align: middle;
    color: white;
    padding: 50px 40px;
    margin-left: 60px;
    font-size: 15pt;
}

.medium-title h2 {
    font-size: 30pt;
}

.img-contnt {
    text-align: right;
}

.container-fluid,
.col-md-9,
.col-md-6,
.col-md-3,
.col-md-10,
.col-md-12 {
    padding-left: 0px !important;
    padding-right: 0px !important;
}

.row,
.col-md-9,
.col-md-3,
.col-md-10,
.col-md-12 {
    margin-left: 0px!important;
    margin-right: 0px!important;
}


@media screen and (max-width:1300px) {
    #misionpage {
        background-color: $azul;
        color: white;
        margin-top: -100px;
    }
}

@media screen and (max-width:1040px) {
    #misionpage {
        margin-top: 0px;
    }

    p {
        max-width: 300px;
    }

    .medium-title {
        text-align: left;
        vertical-align: middle;
        color: white;
        padding: 10px 40px;
        margin-left: 0px;
        font-size: 15pt;
    }

    .main-content {
        margin-top: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// MisionPage.vue?52a3e647